import { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

import { AppBar, AppBarSection, AppBarSpacer } from '@progress/kendo-react-layout';
import { DropDownButton, DropDownButtonItem } from '@progress/kendo-react-buttons';

import { selectUserProfile } from '../../../features/common/auth/auth-slice';

import { useExtendedLocalization } from '../../../hooks/use-extended-localization-service';

import { logout } from '../../../features';

import styles from './header.module.scss';
import logo from '../../../assets/UmojoLogo.svg';
import { useAppSelector } from '../../../store/hooks';

const Header: FunctionComponent = () => {
  const isAuthenticated = useIsAuthenticated();
  const userProfile = useAppSelector(selectUserProfile);
  const localization = useExtendedLocalization();

  if (!isAuthenticated) return null;

  const theme = 'dark';

  const onItemClick = (text: string) => {
    switch (text) {
      case 'Logout': {
        logout();
        break;
      }
      default: {
        break;
      }
    }
  };

  return (
    <header className={styles.header}>
      <AppBar className={styles.appBar} themeColor={theme}>
        <AppBarSection style={{width: 50}}>
          <NavLink to='/'>
            <img className={styles.logo} src={logo} alt='logo' />
          </NavLink>
        </AppBarSection>

        <AppBarSection>
          <ul>
            <li style={{marginLeft: 0}}>
              <NavLink className={styles.link} to='/dashboard'>
                {localization.toLanguageStringF('header.menu.dashboard')}
              </NavLink>
            </li>
            <li>
              <NavLink className={styles.link} to='/customers'>
                {localization.toLanguageStringF('header.menu.customers')}
              </NavLink>
            </li>
            <li>
              <NavLink className={styles.link} to='/locations'>
                {localization.toLanguageStringF('header.menu.locations')}
              </NavLink>
            </li>
            {userProfile?.isAdmin && (
              <li>
                <NavLink className={styles.link} to='/nexparkops'>
                  NexPark Ops Panel
                </NavLink>
              </li>
            )}
          </ul>
        </AppBarSection>

        <AppBarSpacer />

        <AppBarSection>
          <DropDownButton
            icon='arrow-60-down'
            buttonClass={styles.dropdownUsername}
            themeColor='light'
            fillMode='link'
            rounded='small'
            text={userProfile?.name}
            onItemClick={(evt) => onItemClick(evt.item.text)}
          >
            <DropDownButtonItem text={localization.toLanguageStringF('header.menu.logout')} icon='logout' />
          </DropDownButton>
        </AppBarSection>
      </AppBar>
    </header>
  );
};

export default Header;
